export default function Logo() {
  return (
    <a href="#top" data-testid="brand-logo" className="flex items-center gap-3">
      <span className="bg-[#E60000] text-white font-display px-2.5 py-1.5 text-xl leading-none tracking-tight">
        4T
      </span>
      <span className="font-mono text-[10px] sm:text-xs tracking-[0.3em] text-white leading-tight">
        TELLTHEM
        <br />
        SOCKS
      </span>
    </a>
  );
}
